module.exports = __webpack_public_path__ + "static/media/open_btn.ae3ca2f5.png";